import { ClickAwayListener, Grow, Link, MenuItem, Paper, Popper, Tab } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { useTranslation } from 'react-i18next';
import ArrowRepeatIcon16pxSvg from '../../../assets/images/icons/ArrowRepeatIcon16pxSvg';
import BoxArrowInDown16pxSvg from '../../../assets/images/icons/BoxArrowInDown16pxSvg';
import BoxArrowInUp16pxSvg from '../../../assets/images/icons/BoxArrowInUp16pxSvg';
import IphoneFillIcon16oxSvg from '../../../assets/images/icons/IphoneFillIcon16oxSvg';
import IphoneOutlineIcon16pxSvg from '../../../assets/images/icons/IphoneOutlineIcon16pxSvg';
import PencilEditIcon16pxSvg from '../../../assets/images/icons/PencilEditIcon16pxSvg';
import PersonXIcon16pxSvg from '../../../assets/images/icons/PersonXIcon16pxSvg';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import UserCircleIcon16pxSvg from '../../../assets/images/icons/UserCircleIcon16pxSvg';
import UserGroupDoubleFillIcon16pxSvg from '../../../assets/images/icons/UserGroupDoubleFillIcon16pxSvg';
import DefaultTooltip from '../../../components/DefaultTooltip';
import {
   ControlpanelErrorButton,
   ControlpanelInfo2thButton,
   ControlpanelPrimaryButton,
   ControlpanelPurple2thButton,
   ControlpanelSecondaryButton,
   ControlpanelSuccess2thButton,
   ControlpanelWarningButton,
} from '../../../components/StyledButton';
import { CustomAdvancedMenuList, CustomTabPanel, CustomTabsV2 } from '../../../components/StyledComponents';
import { StyledLink } from '../../../components/StyledLink';
import SelectDataToExportUsersDialog from '../UserManagement/SelectDataToExportUsersDialog';
import SelectDataToImportUsersDialog from '../UserManagement/SelectDataToImportUsersDialog';
import UnregisterDeviceDialog from '../UserManagement/UnregisterDeviceDialog';
import ChevronDownColor10pxSvg from './../../../assets/images/icons/ChevronDownColor10pxSvg';
import EditIcon14pxSvg from './../../../assets/images/icons/EditIcon14pxSvg';
import SettingIcon14pxSvg from './../../../assets/images/icons/SettingIcon14pxSvg';
import UserFillIcon16pxSvg from './../../../assets/images/icons/UserFillIcon16pxSvg';
import UserSecretIcon16pxSvg from './../../../assets/images/icons/UserSecretIcon16pxSvg';
import XIcon14pxSvg from './../../../assets/images/icons/XIcon14pxSvg';
import DeleteAllUsersDialog from './DeleteAllUsersDialog';
import DeleteUserGroupDialog from './DeleteUserGroupDialog';
import EditUserGroupDialog from './EditUserGroupDialog';
import RemoveUserFromGroupDialog from './RemoveUserFromGroupDialog';
import RestoreDeletedUserDialog from './RestoreDeletedUserDialog';
import SelectGroupAdminDialog from './SelectGroupAdminDialog';
import SelectUsersForUserGroupDialog from './SelectUsersForUserGroupDialog';
import SettingUserGroupDialog from './SettingUserGroupDialog';
import UserGroupRegisterDevicesDialog from './UserGroupRegisterDevicesDialog';
import AddUserToGroupDialog from './AddUserToGroupDialog';
import RegistersDeviceDialog from './RegistersDeviceDialog';
import my_company_logo from "../../../assets/images/logo/my-company-logo.png";
import CustomSplitButtonEdit from '../../../components/CustomSplitButtonEdit';
import EditNew20pxSvg from '../../../assets/images/icons/EditNew20pxSvg';
import AttachedUsersFor from './AttachedUsersFor';
import GroupAdminGridInfoTable from './GroupAdminGridInfoTable';

const UserGroupInfo = (props) => {
   const { t, i18n } = useTranslation();
   const { info, userGroup, adminGroup, handleRefreshTable, userData, refreshInfo, handleRefreshInfo, getStatusAddNewGroup, refreshData } = props;
   // const [userData, setUserData] = useState([]);
   const currentLang = i18n.language;
   const isLoaded = Boolean(info && info.id);

   const isHasAdmin = adminGroup && adminGroup.length > 0;
   const [openGroupUser, setOpenGroupUser] = useState(false);
   const anchorRefGroupUser = useRef(null);
   const [selectedUserGroup, setSelectedUserGroup] = useState({});
   const [tabValue, setTabValue] = useState(0);

   const handleToggleGroupUser = () => {
      setOpenGroupUser(!openGroupUser);
   };

   const handleCloseGroupUser = (event) => {
      if (anchorRefGroupUser.current && anchorRefGroupUser.current.contains(event.target)) {
         return;
      }
      setOpenGroupUser(false);
   };

   const [openDeleteUserGroup, setOpenDeleteUserGroup] = useState(false);
   const handleOpenDeleteUserGroup = () => {
      setOpenDeleteUserGroup(true);
   };

   const handleCloseDeleteUserGroup = () => {
      setOpenDeleteUserGroup(false);
   };

   const [openSettingUserGroup, setOpenSettingUserGroup] = useState(false);
   const handleOpenSettingUserGroup = () => {
      setOpenSettingUserGroup(true);
   };

   const handleCloseSettingUserGroup = () => {
      setOpenSettingUserGroup(false);
   };

   const [openEditUserGroup, setOpenEditUserGroup] = useState(false);
   const handleOpenEditUserGroup = () => {
      setOpenEditUserGroup(true);
   };

   const handleCloseEditUserGroup = () => {
      setOpenEditUserGroup(false);
   };

   const [openGroupAdmin, setOpenGroupAdmin] = useState(false);

   const handleOpenGroupAdmin = () => {
      setOpenGroupAdmin(true);
   };

   const handleCloseGroupAdmin = () => {
      setOpenGroupAdmin(false);
   };

   const [openRegisterDevices, setOpenRegisterDevices] = useState(false);

   const handleOpenRegisterDevices = (userGroup) => {
      setSelectedUserGroup(userGroup);
      setOpenRegisterDevices(true);
   };

   const handleCloseRegisterDevices = () => {
      setOpenRegisterDevices(false);
   };

   const [openUnregisterDevice, setOpenUnregisterDevice] = useState(false);
   const [selectedDeviceName, setSelectedDeviceName] = useState({});
   const handleOpenUnregisterDevice = (deviceName) => {
      setSelectedDeviceName(deviceName);
      setOpenUnregisterDevice(true);
   };

   const handleCloseUnregisterDevice = () => {
      setOpenUnregisterDevice(false);
   };

   const [openRemoveUserFromGroup, setOpenRemoveUserFromGroup] = useState(false);
   const [selectedUserRemove, setSelectedUserRemove] = useState({});
   const handleOpenRemoveUserFromGroup = (userRemove) => {
      setSelectedUserRemove(userRemove);
      setOpenRemoveUserFromGroup(true);
   };

   const handleCloseRemoveUserFromGroup = () => {
      setOpenRemoveUserFromGroup(false);
   };

   const [openDeleteAllUsers, setOpenDeleteAllUsers] = useState(false);

   const handleOpenDeleteAllUsers = () => {
      setOpenDeleteAllUsers(true);
   };

   const handleCloseDeleteAllUsers = () => {
      setOpenDeleteAllUsers(false);
   };

   const [openRestoreDeletedUser, setOpenRestoreDeletedUser] = useState(false);

   const handleOpenRestoreDeletedUser = () => {
      setOpenRestoreDeletedUser(true);
   };

   const handleCloseRestoreDeletedUser = () => {
      setOpenRestoreDeletedUser(false);
   };

   const [openSelectDataToImport, setOpenSelectDataToImport] = useState(false);

   const handleOpenSelectDataToImport = () => {
      setOpenSelectDataToImport(true);
   };

   const handleCloseSelectDataToImport = () => {
      setOpenSelectDataToImport(false);
   };

   const [openSelectDataToExport, setOpenSelectDataToExport] = useState(false);

   const handleOpenSelectDataToExport = () => {
      setOpenSelectDataToExport(true);
   };

   const handleCloseSelectDataToExport = () => {
      setOpenSelectDataToExport(false);
   };

   const [openSelectUserForUserGroup, setOpenSelectUserForUserGroup] = useState(false);

   const handleOpenSelectUserForUserGroup = () => {
      setOpenSelectUserForUserGroup(true);
      setOpenGroupUser(false);
   };

   const handleCloseSelectUserForUserGroup = () => {
      setOpenSelectUserForUserGroup(false);
   };

   const [openAddUsertoGroup, setOpenAddUsertoGroup] = useState(false);

   const handleOpenAddUsertoGroup = () => {
      setOpenAddUsertoGroup(true);

      setOpenGroupUser(false);
   };

   const handleCloseAddUsertoGroup = () => {
      setOpenAddUsertoGroup(false);
   };

   const [openActions, setOpenActions] = useState(false);
   const anchorRefActions = useRef(null);
   // Hiện nút Edit/Actions khi tour (nhóm All users id=1 bình thường bị ẩn)
   const [tourForceShowActions, setTourForceShowActions] = useState(false);

   const handleToggleActions = () => {
      setOpenActions((prev) => !prev);
   };

   const handleCloseActions = (event) => {
      if (
         anchorRefActions.current &&
         anchorRefActions.current.contains(event.target)
      ) {
         return;
      }

      setOpenActions(false);
   };

   // Tour: mở edit / menu / dialog / chuyển tab
   useEffect(() => {
      const closeTourDialogs = () => {
         setOpenEditUserGroup(false);
         setOpenSelectUserForUserGroup(false);
         setOpenGroupAdmin(false);
         setOpenDeleteUserGroup(false);
         setOpenActions(false);
      };

      window.__showUserGroupEditActions = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setTabValue(0);
            closeTourDialogs();
         });
      };
      window.__hideUserGroupEditActions = () => {
         flushSync(() => {
            setTourForceShowActions(false);
            closeTourDialogs();
         });
      };
      window.__openUserGroupEditDialog = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setTabValue(0);
            closeTourDialogs();
            setOpenEditUserGroup(true);
         });
      };
      window.__closeUserGroupEditDialog = () => {
         flushSync(() => setOpenEditUserGroup(false));
      };
      window.__openUserGroupActionsMenu = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setOpenEditUserGroup(false);
            setOpenSelectUserForUserGroup(false);
            setOpenGroupAdmin(false);
            setOpenDeleteUserGroup(false);
            setOpenActions(true);
         });
      };
      window.__closeUserGroupActionsMenu = () => {
         flushSync(() => setOpenActions(false));
      };
      window.__openUserGroupUsersDialog = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setOpenActions(false);
            setOpenEditUserGroup(false);
            setOpenGroupAdmin(false);
            setOpenDeleteUserGroup(false);
            setOpenSelectUserForUserGroup(true);
         });
      };
      window.__closeUserGroupUsersDialog = () => {
         flushSync(() => setOpenSelectUserForUserGroup(false));
      };
      window.__openUserGroupAdminsDialog = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setOpenActions(false);
            setOpenEditUserGroup(false);
            setOpenSelectUserForUserGroup(false);
            setOpenDeleteUserGroup(false);
            setOpenGroupAdmin(true);
         });
      };
      window.__closeUserGroupAdminsDialog = () => {
         flushSync(() => setOpenGroupAdmin(false));
      };
      window.__openUserGroupDeleteDialog = () => {
         flushSync(() => {
            setTourForceShowActions(true);
            setOpenActions(false);
            setOpenEditUserGroup(false);
            setOpenSelectUserForUserGroup(false);
            setOpenGroupAdmin(false);
            setOpenDeleteUserGroup(true);
         });
      };
      window.__closeUserGroupDeleteDialog = () => {
         flushSync(() => setOpenDeleteUserGroup(false));
      };
      window.__setUserGroupInfoTab = (index) => {
         flushSync(() => {
            closeTourDialogs();
            setTourForceShowActions(false);
            setTabValue(index);
         });
      };

      return () => {
         delete window.__showUserGroupEditActions;
         delete window.__hideUserGroupEditActions;
         delete window.__openUserGroupEditDialog;
         delete window.__closeUserGroupEditDialog;
         delete window.__openUserGroupActionsMenu;
         delete window.__closeUserGroupActionsMenu;
         delete window.__openUserGroupUsersDialog;
         delete window.__closeUserGroupUsersDialog;
         delete window.__openUserGroupAdminsDialog;
         delete window.__closeUserGroupAdminsDialog;
         delete window.__openUserGroupDeleteDialog;
         delete window.__closeUserGroupDeleteDialog;
         delete window.__setUserGroupInfoTab;
      };
   }, []);

   const groupManagers = useMemo(() => {
      return adminGroup?.filter(item => item.isManager) || [];
   }, [adminGroup]);

   const handleChangeTab = (event, newValue) => {
      setTabValue(newValue);
   };

   const a11yProps = (index) => {
      return {
         id: `user-tab-${index}`,
         'aria-controls': `user-tabpanel-${index}`,
      };
   };

   const isHasManager = groupManagers.length > 0;

   const userGroupMap = useMemo(() => {
      return userGroup.reduce((acc, user) => {
         acc[user.id] = user.fullName;
         return acc;
      }, {});
   }, [userGroup]);

   const handleRemoveAdmin = (admin) => {
      setSelectedUserRemove({
         userId: admin.userId,
         fullName: userGroupMap[admin.userId] || admin.userId
      });
      setOpenRemoveUserFromGroup(true);
   };

   const totalAdmins = useMemo(() => {
      return adminGroup.length
   }, [adminGroup]);

   const showEditActions = info?.id !== 1 || tourForceShowActions;

   return (
      <div className="card px-3 py-3 flex flex-col h-full">
         <div className='flex gap-3 items-center'>
            <p className="text-xl font-semibold">
               {info?.groupName === "All users"
                  ? t("common.all-user")
                  : info?.groupName}
            </p>
            {/* <div className='grey-chip'>{info.groupName}</div> */}
            <DefaultTooltip
               readMore={true}
               title={t('tool-tip.user-group-quick-view')}
               content={
                  <div className='flex flex-col gap-3'>
                     <p>{t('tool-tip.this-view-is-showing-user-group-details-and-allow')}</p>
                  </div>
               }
            >
               <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
            </DefaultTooltip>
         </div>
         <CustomTabsV2
            variant="fullWidth"
            indicatorColor='none'
            value={tabValue}
            onChange={handleChangeTab}
         >
            <Tab
               label={t('button.details')}
               {...a11yProps(0)}
               disableRipple
               data-tour="user-group-detail-tab"
            />

            <Tab
               label={t('common.employee')}
               {...a11yProps(1)}
               disableRipple
               data-tour="user-group-employee-tab"
            />

            <Tab
               label={t('roles.Admin')}
               {...a11yProps(2)}
               disableRipple
               data-tour="user-group-admin-tab"
            />

            <Tab
               label={t('common.devices')}
               {...a11yProps(3)}
               disableRipple
               disabled
            />
         </CustomTabsV2>

         <div className='flex gap-2 justify-end mt-2'>
            {showEditActions && (
               <>
                  <div data-tour="user-group-edit-button">
                     <CustomSplitButtonEdit
                        ref={anchorRefActions}
                        label={t("button.edit")}
                        startIcon={<EditNew20pxSvg />}
                        onMainClick={handleOpenEditUserGroup}
                        onDropdownClick={handleToggleActions}
                        disabled={info?.id === 0}
                     />
                  </div>

                  <Popper
                     open={openActions}
                     anchorEl={anchorRefActions.current}
                     placement="bottom-end"
                     transition
                     sx={{
                        zIndex: 9999,
                     }}
                  >
                     {({ TransitionProps }) => (
                        <Grow
                           {...TransitionProps}
                           timeout={window.__tourIsOpen ? 0 : undefined}
                        >
                           <Paper sx={{ borderRadius: 1, p: 0, mt: 1 }}>
                              <ClickAwayListener
                                 onClickAway={(e) => {
                                    if (window.__tourIsOpen) return;
                                    handleCloseActions(e);
                                 }}
                              >
                                 <CustomAdvancedMenuList>

                                    {/* Group Users */}
                                    <MenuItem
                                       data-tour="user-group-button-group-user"
                                       className="gap-3 items-center h-9 hover:!bg-blue-100"
                                       onClick={(e) => {
                                          handleOpenSelectUserForUserGroup();
                                          handleCloseActions(e);
                                       }}
                                    >
                                       <UserGroupDoubleFillIcon16pxSvg />
                                       <p>{t("button.group-users")}</p>
                                    </MenuItem>

                                    {/* Group Admins */}
                                    <MenuItem
                                       data-tour="user-group-button-group-admin"
                                       className="gap-3 items-center h-9 hover:!bg-blue-100"
                                       onClick={(e) => {
                                          handleOpenGroupAdmin();
                                          handleCloseActions(e);
                                       }}
                                    >
                                       <UserFillIcon16pxSvg />
                                       <p>{t("button.group-admins")}</p>
                                    </MenuItem>

                                    {/* Register Devices - disabled */}
                                    <MenuItem
                                       className="gap-3 items-center h-9 hover:!bg-blue-100"
                                       sx={{
                                          opacity: 0.5,
                                          pointerEvents: "none",
                                       }}
                                    >
                                       <IphoneFillIcon16oxSvg />
                                       <p>{t("button.register-devices")}</p>
                                    </MenuItem>

                                    {/* Settings - disabled */}
                                    <MenuItem
                                       className="gap-3 items-center h-9 hover:!bg-blue-100"
                                       sx={{
                                          opacity: 0.5,
                                          pointerEvents: "none",
                                       }}
                                    >
                                       <SettingIcon14pxSvg />
                                       <p>{t("button.settings")}</p>
                                    </MenuItem>

                                    {/* Delete */}
                                    <MenuItem
                                       data-tour="user-group-button-delete"
                                       className="gap-3 items-center h-9 !text-red-500"
                                       onClick={(e) => {
                                          handleOpenDeleteUserGroup();
                                          handleCloseActions(e);
                                       }}
                                    >
                                       <XIcon14pxSvg />
                                       <p>{t("button.delete")}</p>
                                    </MenuItem>

                                 </CustomAdvancedMenuList>
                              </ClickAwayListener>
                           </Paper>
                        </Grow>
                     )}
                  </Popper>
               </>
            )}
         </div>

         <CustomTabPanel value={tabValue} index={0}>
            <div className={`flex-1 overflow-y-auto pr-2 flex flex-col gap-3 ${info?.id === 1 ? 'h-[69vh]' : 'h-[65vh]'}`}>
               {/* ===== Avatar ===== */}
               <div className="flex justify-center">
                  <div className="p-1 rounded border border-[#E5E7EB]">
                     <img
                        src={
                           info?.profilePicture
                              ? `data:image/png;base64,${info?.profilePicture}`
                              : my_company_logo
                        }
                        alt="avatar"
                        className="w-[128px] h-[128px] object-cover rounded"
                     />
                  </div>
               </div>
               <div className='grid grid-cols-3'>
                  <div className='col-span-1 flex items-center gap-1'>
                     <p className='font-semibold capitalize text-[#6B7280]'>{t('common.group-name')}</p>
                  </div>
                  <div className='col-span-2 flex flex-col gap-1'>
                     {!isLoaded ? (
                        <div />
                     ) : (
                        <p>{info?.groupName === "All users" ? t("common.all-user") : info?.groupName}</p>
                     )}
                  </div>

               </div>

               <div className='grid grid-cols-3'>
                  <div className='col-span-1 flex items-center gap-1'>
                     <p className='font-semibold capitalize text-[#6B7280]'>{t('common.description')}</p>
                  </div>
                  <div className='col-span-2 flex flex-col gap-1'>
                     {!isLoaded ? (
                        <div />
                     ) : (
                        <p>{info?.remark === "Default group for all users" ? t("common.default-group-for-all-users") : info?.remark}</p>
                     )}
                  </div>

               </div>

               <div className='grid grid-cols-3'>
                  <div className='col-span-1 flex items-center gap-1'>
                     <p className='font-semibold text-[#6B7280]'>{t('common.total-users')}</p>
                  </div>
                  <div className='col-span-2 flex flex-col gap-1'>
                     {!isLoaded ? (
                        <div />
                     ) : (
                        <p>{userGroup?.length}</p>
                     )}
                  </div>

               </div>

               <div className='grid grid-cols-3'>
                  <div className='col-span-1 flex items-center gap-1'>
                     <p className='font-semibold text-[#6B7280]'>
                        {t('common.total-admins')}
                     </p>
                  </div>

                  <div className='col-span-2 flex flex-col gap-1'>
                     {!isLoaded ? (
                        <div />
                     ) : (
                        <p>{totalAdmins}</p>
                     )}
                  </div>
               </div>
            </div>
         </CustomTabPanel>

         <CustomTabPanel value={tabValue} index={1}>
            <AttachedUsersFor selectedRows={info} refreshData={refreshData} handleRefreshTable={handleRefreshTable} userData={userData} refreshInfo={refreshInfo} handleRefreshInfo={handleRefreshInfo}></AttachedUsersFor>
         </CustomTabPanel>

         <CustomTabPanel value={tabValue} index={2}>
            <GroupAdminGridInfoTable selectedRows={info} refreshData={refreshData} handleRefreshTable={handleRefreshTable} userData={userData} refreshInfo={refreshInfo} handleRefreshInfo={handleRefreshInfo} adminGroup={adminGroup} />
         </CustomTabPanel>


         {openSelectUserForUserGroup && <AddUserToGroupDialog isOpen={openSelectUserForUserGroup} onClose={handleCloseSelectUserForUserGroup} info={info} handleRefreshTable={handleRefreshTable} userGroup={userGroup} userData={userData} handleRefreshInfo={handleRefreshInfo} />}
         {openEditUserGroup && <EditUserGroupDialog onClose={handleCloseEditUserGroup} info={info} handleRefreshTable={handleRefreshTable} getStatusAddNewGroup={getStatusAddNewGroup} />}
         {openUnregisterDevice && <UnregisterDeviceDialog onClose={handleCloseUnregisterDevice} selectedDeviceName={selectedDeviceName} />}
         <RemoveUserFromGroupDialog
            open={openRemoveUserFromGroup}
            onClose={handleCloseRemoveUserFromGroup}
            selectedUserRemove={selectedUserRemove}
            groupId={info?.id}
            groupName={info?.groupName}
            groupCode={info?.groupCode}
            handleRefreshInfo={handleRefreshInfo}
         />

         {openGroupAdmin && (
            <SelectGroupAdminDialog
               isOpen={openGroupAdmin}
               onClose={handleCloseGroupAdmin}
               info={info}
               handleRefreshTable={handleRefreshTable}
               userGroup={userGroup}
               adminGroup={adminGroup}
               handleRefreshInfo={handleRefreshInfo}
            />
         )}

         <RegistersDeviceDialog
            open={openRegisterDevices}
            handleClose={handleCloseRegisterDevices}
            selectedUserGroup={info}
            handleRefreshTable={handleRefreshTable}
         />
         <SettingUserGroupDialog open={openSettingUserGroup} handleClose={handleCloseSettingUserGroup} users={info?.groupMember} />
         <DeleteUserGroupDialog open={openDeleteUserGroup} handleClose={handleCloseDeleteUserGroup} handleRefreshTable={handleRefreshTable} info={info} adminGroup={adminGroup} />
      </div>
   );
};

export default UserGroupInfo;
